export default {
  name: 'radio',
  type: 'action',
  isRequired: true,
  essential: false
}
